import { ApplicationConfigWithPages } from '../../shared/features/ng-redux/app/appConfig.models';
import { mapAppConfigs } from './config-mapper/app-mapper';

export class DashboardConfigMapper {
  static mapAppConfigs(apps: ApplicationConfigWithPages[]): ApplicationConfigWithPages[] {
    return mapAppConfigs(apps);
  }
}
